module.exports = __webpack_public_path__ + "files/b298fdb16c491c99454e4dd61e279fee.png";